// components/sectors/CoordinateCompletionDialog.jsx
import { useState } from 'react';
import apiService from '../../shared/services/ApiService';
import './CoordinateCompletionDialog.css';

const CoordinateCompletionDialog = ({ 
    isOpen, 
    onClose, 
    sectorId, 
    sectorName,
    coordinateIndex, 
    totalCoordinates,
    onComplete 
}) => {
    const [formData, setFormData] = useState({
        comment: '',
        workDone: '',
        issues: '',
        workType: 'trimmer'
    });
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await apiService.post(
                `/api/sectores/${sectorId}/coordinates/complete`,
                {
                    coordinateIndex,
                    ...formData
                }
            );

            if (response.data.success) {
                alert(`✅ Punto ${coordinateIndex + 1} completado exitosamente`);
                onComplete && onComplete(response.data);
                onClose();
            }
        } catch (error) {
            console.error('Error completando punto:', error);
            alert(error.response?.data?.message || 'Error al completar el punto');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="completion-dialog-overlay">
            <div className="completion-dialog">
                <div className="completion-dialog-header">
                    <h2>Completar Punto {coordinateIndex + 1}/{totalCoordinates}</h2>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="completion-dialog-body">
                    <div className="sector-info">
                        <strong>Sector:</strong> {sectorName}
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="workType">Tipo de Trabajo:</label>
                            <select
                                id="workType"
                                value={formData.workType}
                                onChange={(e) => setFormData({ ...formData, workType: e.target.value })}
                                className="work-type-select"
                            >
                                <option value="trimmer">Corte / Mantenimiento de Cesped</option>
                                <option value="tree">Poda / Corte / Siembra de Arboles</option>
                                <option value="ornamental">Mantenimiento de Ornato (Arbustos)</option>
                                <option value="other">Otro</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="workDone">
                                <span className="required">*</span> Trabajo Realizado:
                            </label>
                            <textarea
                                id="workDone"
                                value={formData.workDone}
                                onChange={(e) => setFormData({ ...formData, workDone: e.target.value })}
                                placeholder="Describe el trabajo realizado en este punto..."
                                required
                                rows="4"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="issues">Problemas Encontrados:</label>
                            <textarea
                                id="issues"
                                value={formData.issues}
                                onChange={(e) => setFormData({ ...formData, issues: e.target.value })}
                                placeholder="¿Se encontraron problemas? (Opcional)"
                                rows="3"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="comment">Comentarios Adicionales:</label>
                            <textarea
                                id="comment"
                                value={formData.comment}
                                onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
                                placeholder="Comentarios adicionales... (Opcional)"
                                rows="3"
                            />
                        </div>

                        <div className="form-actions">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancelar
                            </button>
                            <button 
                                type="submit" 
                                className="btn btn-success"
                                disabled={loading}
                            >
                                {loading ? 'Guardando...' : '✓ Completar Punto'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CoordinateCompletionDialog;